import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { Box, InputLabel, MenuItem, Select, Stack } from "@mui/material";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { produce } from "immer";
import { useMemo } from "react";
import FormSection from "../../../../../Components/Forms/FormSection/form-section";
import { PlanningMode } from "../../../../../Core/Api/Types/planning-mode";
import { PlanningView } from "../../../../../Core/Api/Types/planning-view";
import { SectionGlobalProps } from "../settings-global";
import { useTranslation } from "react-i18next";

const SettingsGlobalSectionPlanning = (props: SectionGlobalProps) => {
  const { t } = useTranslation();
  const { platformInfos, setPlatformInfos } = props;

  const defaulPlanningTaskDuration = useMemo(() => {
    const [hours, minutes] = (platformInfos.defaulPlanningTaskDuration || "00:00").split(":").map(Number);
    return dayjs().set("hour", hours).set("minute", minutes).set("second", 0);
  }, [platformInfos.defaulPlanningTaskDuration]);

  return (
    <FormSection title={t("common:planning")} status="todo" sx={{ mb: 2 }}>
      <Stack spacing={2}>
        <Box>
          <InputLabel sx={{ mb: 1 }}>{t("field:label.planningDefaultMode")}</InputLabel>
          <Select
            IconComponent={ExpandMoreRoundedIcon}
            value={platformInfos.defaultPlanningMode || ""}
            onChange={(e) =>
              setPlatformInfos(
                produce((draft) => {
                  draft.defaultPlanningMode = e.target.value as PlanningMode;
                })
              )
            }
          >
            <MenuItem value={PlanningMode.Agenda}>{PlanningMode.Agenda}</MenuItem>
            <MenuItem value={PlanningMode.Calendar}>{PlanningMode.Calendar}</MenuItem>
            <MenuItem value={PlanningMode.Schedule}>{PlanningMode.Schedule}</MenuItem>
            <MenuItem value={PlanningMode.Timeline}>{PlanningMode.Timeline}</MenuItem>
          </Select>
        </Box>
        <Box>
          <InputLabel sx={{ mb: 1 }}>{t("field:label.planningDefaultView")}</InputLabel>
          <Select
            IconComponent={ExpandMoreRoundedIcon}
            value={platformInfos.defaultPlanningView || ""}
            onChange={(e) =>
              setPlatformInfos(
                produce((draft) => {
                  draft.defaultPlanningView = e.target.value as PlanningView;
                })
              )
            }
          >
            <MenuItem value={PlanningView.Day}>{PlanningView.Day}</MenuItem>
            <MenuItem value={PlanningView.Week}>{PlanningView.Week}</MenuItem>
            <MenuItem value={PlanningView.Month}>{PlanningView.Month}</MenuItem>
            <MenuItem value={PlanningView.Year}>{PlanningView.Year}</MenuItem>
          </Select>
        </Box>
        <Box>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
              label={t("field:label.defaultTaskDuration")}
              value={defaulPlanningTaskDuration}
              onChange={(value) =>
                setPlatformInfos(
                  produce((draft) => {
                    draft.defaulPlanningTaskDuration = value?.format("HH:mm") || "00:00";
                  })
                )
              }
              views={["hours", "minutes"]}
              ampm={false}
            />
          </LocalizationProvider>
        </Box>
      </Stack>
    </FormSection>
  );
};

export default SettingsGlobalSectionPlanning;
